import { render, staticRenderFns } from "./auth-card.vue?vue&type=template&id=4675855d&"
import script from "./auth-card.vue?vue&type=script&lang=js&"
export * from "./auth-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports